import { ChangeEvent } from "react";

import { updateQueryVariable } from "@/utils/url/queryParams";

import { useProductComparisonContext } from "../productComparison.context";
import { ActionsComponent } from "./actions.component";

type ActionsProps = {
    className?: string;
};

const Actions = ({ className }: ActionsProps) => {
    const { differenceOnly, setDifferenceOnly } = useProductComparisonContext();

    const handleOnShowOnlyDifferenceChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const checked = (event.target as HTMLInputElement).checked;

        setDifferenceOnly(checked);
        updateQueryVariable("showOnlyDifference", `${checked}`);
    };

    return (
        <ActionsComponent
            className={className}
            differenceOnly={differenceOnly}
            onShowOnlyDifferenceChange={handleOnShowOnlyDifferenceChange}
        />
    );
};

export { Actions };
